import React from 'react'
import { FaComment, FaHome, FaIndustry, FaProjectDiagram, FaRoad, FaShippingFast } from 'react-icons/fa'
import { motion } from 'framer-motion'



const HomeServices = [
  {
    title:"Residential Construction",
    icon: FaHome,
    desc: "We design and build durable, modern homes tailored to comfort, style, and long-term value." 
  },
  {
    title: "Commercial Construction",
    icon: FaIndustry,
    desc: "From office complexes to retail spaces, we deliver functional and future-ready commercial buildings."
  },
  {
    title: "Civil Engineering Services",
    icon: FaRoad,
    desc: "We provide expert infrastructure solutions — from roadworks to drainage systems — built to support sustainable communities."
  },
  {
    title: " Logistics Solutions",
    icon: FaShippingFast,
    desc: "We manage the seamless movement of materials, equipment, and supplies — ensuring timely delivery and project flow."
  },
  {
    title: "Consulting Services",
    icon: FaComment,
    desc: "Our specialists offer strategic guidance and project planning to ensure efficient, cost-effective execution from start to finish."
  },
  {
    title: "Project Management",
    icon: FaProjectDiagram,
    desc: "We oversee every phase of your project with precision, ensuring quality control, budget alignment, and timely completion."
  }

]

const HomepageServices = () => {
  return (
    <div className='relative bg-gradient-to-r from-[#8be89e] to [rgb(41,49,63)] text-gray-900 py-10'>
      {/* opacity */}
      <div className='absolute inset-0 bg-black opacity-20'>
      </div>

      {/* services listed out */}
      <div className='relative max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-col-3 gap-6 px-4 z-10'>
        {HomeServices.map((service, index) => {
          const Icon = service.icon;

          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.3 }}
              viewport={{ once: false, amount: 0.3 }}
              className='bg-white shadow-lg rounded-xl overflow-hidden hover:shadow-xl transform transition-all'
            >
              <div className='p-6 text-center'>
                <Icon className='mb-4 text-5xl text-[rgb(41,49,63)] mx-auto'/>

                <h3 className='text-2xl font-semibold mb-4 text-[rgb(41,49,63)]'>
                  {service.title}
                </h3>

                <p className="text-gray-600">
                  {service.desc}
                </p>
                
              </div>

            </motion.div>
          )
        })}
      </div>
    </div>
    
  )
}

export default HomepageServices